// extracted by mini-css-extract-plugin
module.exports = {"title":"ChangeEntryAllowedStatusModal_title__1suyl","container":"ChangeEntryAllowedStatusModal_container__3Hgf8"};